import gql from "graphql-tag";
import {internalStatus} from "../../Constants/Constant"

export const GET_TRUCK_ORDERS = gql`
 query truckOrders($startDate:date!, $endDate:date!){
  truckOrders(where: {_and: [{ date: {_gte: $startDate}},{ date: {_lte: $endDate}}]}) {
    id
    truckOrderNumber
    date
    transporterId
    Transporter{id name}
    driverId
    driverDetail{id name}
    truckId
    truck{id name platNo}
    fromCity
    toCity
    pickCity{id shortCode}
    dropCity{id shortCode}
    commitedWeight
    price
    bookingDate
    lrCommision
    ewayBillNo
    status
    orderDetailsArr{
    id
    lrObject
    ewayBillNo
    isEwayBillVerified
    order{
        id
        orderNumber
        clientobject
        pickuppartyobject
        droppingpartyobject
        materials
        note
          }
      }
    }
 }
`
export const GET_EXCEL_TRUCK_ORDERS = gql`
 query truckOrders($startDate:date!, $endDate:date!){
  truckOrders(where: {_and: [{ date: {_gte: $startDate}},{ date: {_lte: $endDate}},{ status: {_eq: "InProgress"}}]}) {
    id
    date
    bookingDate
    truckOrderNumber
    InternalStatus{id name}
    Transporter{id name}
    driverDetail{id name}
    truck{id name platNo}
    orderDetailsArr{order {materials}}
    fromCity
    toCity
    commitedWeight
    price
    lrCommision
    ewayBillNo
    status
    }
 }
`
export const GET_ORDERS_BY_TRUCK_ORDER_ID = gql`
 query orders_by_truckOrderId($truckOrderId: uuid!){
  orders(where: {orderDetails: {transportVehicleAssignId: {_eq: $truckOrderId}}}) {
      id
      clientobject
      pickuppartyobject
      droppingpartyobject
      orderNumber
      pickupDate
      materials
      priority
      note
      notes(order_by: {createdOn: desc}, limit: 1){id note}
      internalstatus
      internalStatus{id name viewPath}
      orderDetails {
        id
        lrObject
        pickupConfirmation
        orderReadiness
        dispactchVerification
        pickupVehicleAssignId
        transportVehicleAssignId
        loadedInTruck
        ewayBillNo
        isEwayBillVerified
        pickupPoint
        dropPoint
      }
    }
 }
`
export const VERIFY_ORDERS_BY_TRUCK_ORDER_ID_AND_STAGE_ID = gql`
 query ordersVerification_by_truckOrderId_and_stageId($truckOrderId: uuid!, $stageId: uuid!){
  orders(where: {orderDetails: {transportVehicleAssignId: {_eq: $truckOrderId}}, internalstatus:{_neq: $stageId}}) {
      id
      orderNumber
    }
 }
`
export const UPDATE_ORDERS_AND_TRUCKORDER_STATUS_USING_TRUCK_ORDER_ID = gql`
 mutation update_orders_and_truckOrder_status_using_truckOrderId($truckOrderId: uuid!, $stageId: uuid!,
          $lastStageUpdatedOn: timestamptz!, $lastStageUpdatedBy: uuid!) {
 update_orders (
    where: {orderDetails: {transportVehicleAssignId: {_eq: $truckOrderId}}}
    _set: {internalstatus: $stageId, lastStageUpdatedOn: $lastStageUpdatedOn, lastStageUpdatedBy: $lastStageUpdatedBy} )
   {
    returning {id}
   }
 update_truckOrders (
    where: {id: {_eq: $truckOrderId}}
    _set: {internalstatus: $stageId} )
   {
    returning {id}
   }
  }
`
export const GET_TRUCK_ORDER_BY_ID = gql`
 query truckOrderDetail($truckOrderId: uuid!){
  truckOrderDetail:truckOrders(where: {id: {_eq: $truckOrderId}}) {
    id
    bookingDate
    truckOrderNumber
    InternalStatus{id name}
    Transporter{id name}
    driverDetail{id name mobile}
    truck{id name platNo}
    fromCity
    toCity
    commitedWeight
    price
    lrCommision
    ewayBillNo
    status
    }
 }
`
export const GET_SINGLE_TRUCK_ORDER = gql`
 query truckOrders($truckOrderId: uuid!){
  truckOrders(where: {id: {_eq: $truckOrderId}}) {
    id
    driverDetail{id name}
    truck{id name}
    }
 }
`
// truckOrders(where: {_and: {date: {_eq: $filterDate}, fromCity: {_eq: $filterCity}}}) {
export const GET_TRUCK_ORDERS_BY_STATUS = gql`
 query truckOrders{
  truckOrders(where: {_and: [{status: {_neq: "Completed"}},{internalstatus: {_eq: ${internalStatus.waitingForDeparture}}}]}) {
    id
    truckOrderNumber
    truck{ id name platNo company{id name} }
    driverDetail{id name}
    orderDetailsArr{
      id
      order{
        id
        orderNumber
        pickuppartyobject
        droppingpartyobject
          }
       }
    }
 }
`
export const GET_OCCUPIED_TRUCKS_AND_DRIVERS = gql`
 query truckOrders($todayDate: date!){
  occupiedTruckAndDriverIds: truckOrders(where: {date: {_eq: $todayDate}}) {
    id
    truckId
    driverId
    }
 }
`
export const GET_LAST_TRUCK_ORDER_NUMBER = gql`
query truckOrders($todayDate: date!){
  lastTruckOrder: truckOrders(where: {date: {_eq: $todayDate}}, order_by: {createdAt: desc}, limit: 1) {
      id
      truckOrderNumber
  }
}
`
export const GET_TRUCK_ORDER_INTERNALSTATUS = gql`
 query truckOrderInternalStatus{
  truckOrderStages: internalstatus(where: {isTruckOrderStatus: {_eq: true}}) {
    id
    name
    }
  }
 `
